// extracted by mini-css-extract-plugin
export default {"container":"Upload_container__sqSAI","content":"Upload_content__fXQkf","nextStepButton":"Upload_nextStepButton__AhzRX","stepper":"Upload_stepper__l-gg7"};